var map = {
	"./artist-and-celeb.png": "7af9",
	"./auction.png": "9b5f",
	"./e-sport.png": "ede9",
	"./event-org.png": "e8e1",
	"./game-developers.png": "cde4",
	"./online-course.png": "6cf2",
	"./patent-org.png": "617f",
	"./publisher.png": "c991",
	"./sport.png": "fd0b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cbf8";